import React from 'react'

import styled from 'styled-components'

import { Colours } from '@lib/theme'

interface AsideProps {
  shade?: keyof typeof Colours.BgShade
  width?: string
  zIndex?: number
}

type Props = AsideProps & {
  children: React.ReactNode
}

const Aside = styled.aside<AsideProps>`
  display: flex;
  flex-direction: column;

  align-items: stretch;
  justify-content: flex-start;

  padding: 1rem 1rem;

  overflow-y: scroll;
  overflow-x: hidden;

  background-color: ${({ shade = 'Light' }) => Colours.BgShade[shade]};

  height: 100%;
  min-width: ${({ width = 'none' }) => width};
  max-width: ${({ width = 'none' }) => width};

  z-index: ${({ zIndex = 'auto' }) => zIndex};

  -webkit-box-shadow: 2px 0px 15px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 2px 0px 15px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 2px 0px 15px 0px rgba(0, 0, 0, 0.75);
`

export function Panel({ children, ...props }: Props) {
  return <Aside {...props}>{children}</Aside>
}
